module.exports = __webpack_public_path__ + "static/media/wavebg_mobile.ccf6cb70.svg";